import {AnimatePresence} from '@sail/engine';
import React, {useCallback, useMemo, useState} from 'react';
import type {CloseConfirmationDialogProps} from '../CloseConfirmationDialog';
import {CloseConfirmationDialog} from '../CloseConfirmationDialog';

export function useCloseBottomSheetWithConfirmation(
  closeWithoutConfirm: () => void,
  confirmCloseMessages?: CloseConfirmationDialogProps['messages'],
) {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [closeConfirmationDialogHeight, setCloseConfirmationDialogHeight] =
    useState<number | null>(null);

  const hasConfirmCloseMessages = !!confirmCloseMessages;

  const requestClose = useCallback(() => {
    if (hasConfirmCloseMessages) {
      setShowConfirmation(true);
    } else {
      closeWithoutConfirm();
    }
  }, [closeWithoutConfirm, hasConfirmCloseMessages]);

  const closeConfirmationDialog = useMemo(() => {
    return (
      <AnimatePresence>
        {confirmCloseMessages && showConfirmation ? (
          <CloseConfirmationDialog
            messages={confirmCloseMessages}
            onCancel={() => {
              setShowConfirmation(false);
              setCloseConfirmationDialogHeight(null);
            }}
            onClose={() => {
              setShowConfirmation(false);
              setCloseConfirmationDialogHeight(null);
              closeWithoutConfirm();
            }}
            onResize={(entry) => {
              setCloseConfirmationDialogHeight(
                // @ts-expect-error - Error after enabling noUncheckedIndexedAccess
                entry.borderBoxSize[0].blockSize,
              );
            }}
          />
        ) : null}
      </AnimatePresence>
    );
  }, [confirmCloseMessages, showConfirmation, closeWithoutConfirm]);

  return {
    requestClose,
    closeConfirmationDialog,
    closeConfirmationDialogHeight,
  };
}
